import { errorHandler } from "./utilities";

export default class Analytics {
  static pageView(pagePath: string) {
    if (!pagePath) {
      errorHandler('missing analytics page path');
    }

    window.xprops.analytics.pageView(pagePath);
  }

  static event(event: { category: string; action: string; value?: string, nonInteraction?: boolean }) {
    if (!event.category || !event.action) {
      errorHandler('missing an event property');
    }

    window.xprops.analytics.event(event);
  }
}
